import {styled} from '@linaria/react';
import React from 'react';
import {
  BaseProductTile,
  BaseProductTileProps,
} from '../BaseProductTile/BaseProductTile';
import {ProductTileWrapper} from '../BaseProductTile/ProductTileWrapper';

export const HeroElementSliderProductTile: React.FC<
  BaseProductTileProps & {
    className?: string;
  }
> = ({className, ...rest}) => {
  return (
    <TileWrapper className={className}>
      <BaseProductTile {...rest} />
    </TileWrapper>
  );
};

const TileWrapper = styled.div`
  height: 100%;

  ${ProductTileWrapper} {
    background: white;
    border-radius: 0.41894rem;
    height: 100%;
  }
`;
